<template>
  <t-config-provider v-bind="$attrs">
    <slot />
  </t-config-provider>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>
